var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Checkbox } from '@mui/material';
import Button from '../atoms/BaseButton';
import Dialog from '../atoms/Dialog';
import DownloadButton from '../molecules/DownloadButton';
var DownloadDeliveryRequestsCSVButton = function (_a) {
    var _b = _a.params, params = _b === void 0 ? {} : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c;
    var t = useTranslation().t;
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var _e = React.useState(false), withItems = _e[0], setWithItems = _e[1];
    var changeWithItems = React.useCallback(function (event, checked) {
        setWithItems(checked);
    }, []);
    var csvParams = React.useMemo(function () { return (__assign(__assign({}, params), { with_items: withItems })); }, [params, withItems]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: function () { return setOpen(true); }, size: size }, t('buttons.downloadCsv')),
        React.createElement(Dialog, { open: open, onClose: function () { return setOpen(false); }, actions: React.createElement(DownloadButton, { key: JSON.stringify(csvParams), path: "/api/delivery_requests/export.csv", downloadFilename: "delivery_requests.csv", params: csvParams, withDownloadTimestamp: true }) },
            React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: withItems, onChange: changeWithItems }), label: t('labels.includesItems') }))));
};
export default DownloadDeliveryRequestsCSVButton;
